const BASE = 'https://api.fromagebaguette.fr';

export interface HeatmapPoint { lat: number; lon: number; value: number; n: number; }
export interface HeatmapBboxResponse { points: HeatmapPoint[]; metric: string; grid: number; count: number; }

export async function fetchHeatmapBbox(params: {
  minLat: number; minLon: number; maxLat: number; maxLon: number;
  metric?: 'rsrp' | 'rsrq' | 'sinr' | 'download_mbps' | 'mos';
  since?: string;
  operator?: string;
}): Promise<HeatmapBboxResponse> {
  const qs = new URLSearchParams({
    minLat: String(params.minLat), minLon: String(params.minLon),
    maxLat: String(params.maxLat), maxLon: String(params.maxLon),
    metric: params.metric ?? 'rsrp',
  });
  if (params.since) qs.set('since', params.since);
  if (params.operator) qs.set('operator', params.operator);
  const r = await fetch(`${BASE}/heatmap/bbox?${qs}`);
  if (!r.ok) throw new Error(`/heatmap/bbox ${r.status}`);
  return r.json();
}
